import { autoinject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';
import { DialogController } from 'aurelia-dialog';

@autoinject
export class GetToken {
    
    token = '';
    isRequesting = true;
    copied = false;

    constructor(private controller: DialogController, private http: HttpClient) {

    }

    
    activate(organizationInputModel) {

        console.log('get-token activate', organizationInputModel);

        this.http.fetch("/api/activationtoken/create", {
            method: 'post',
            body: json(organizationInputModel)
          })
          .then(response => response.text())
          .then(token => {
            console.log(token);
            this.isRequesting = false;
            this.token = token;
          })
          .catch(error => {
            this.isRequesting = false;
            console.log(error);
            
          });
        
    }

    
    copy(){
        try{
            const hiddenElement: HTMLTextAreaElement = document.createElement('textarea');
            hiddenElement.style.display = 'none !important;';
            hiddenElement.innerText = this.token;
            document.body.appendChild(hiddenElement);
            hiddenElement.select();

            document.execCommand('SelectAll');
            document.execCommand('Copy');

            document.body.removeChild(hiddenElement);

            this.copied = true;
        }
        catch {
            console.log("cannot copy token");
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/components/register-organization/get-token.ts